import AdminApi from '../../services/api'
import swal from 'sweetalert2';
import session from "../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            companyId: '',
            filter: '',
            companyName: '',
            openAddOrder: false,
            vehicleToEdit: null,
            vehicles: [],
            types: [],
        }
    },
    computed: {
        filteredUsers() {
            return this.vehicles.filter(item => {
                return item.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.registrationPlate.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 ||
                    item.description.toLowerCase().indexOf(this.filter.toLowerCase()) > -1

            })
        }
    },
    methods: {
        getVehicles: getVehicles,
        deleteVehicle: deleteVehicle,
        isOwnVehicle: isOwnVehicle,
        getFuel: getFuel,
        styleService: styleService,
        parseDate: parseDate,
        styleRegistration: styleRegistration,
        editVehicle: editVehicle,
        openCosts: openCosts,
        keymonitor: keymonitor,
        clickSearch: clickSearch,
        onClickUser: onClickUser,
        openAddUserModal: openAddUserModal,
        compareActive(a, b) {
            let aActive = a.active;
            let bActive = b.active;
            if (aActive)
                return -1;
            if (bActive)
                return 1;
            return 0;
        },

        compareOrders(a, b) {
            let aActive = a.activeOrders;
            let bActive = b.activeOrders;
            if (aActive > bActive)
                return -1;
            if (aActive < bActive)
                return 1;
            return 0;
        },

    },
    created(){
        let _self = this;
        this.$topnavbar.$on('closeAddVehicle', () => {
            _self.openAddOrder = false;
        });



        this.$topnavbar.$on('successAddVehicle', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno dodato vozilo', 'success')
            _self.getVehicles();
        });

        this.$topnavbar.$on('successEditVehicle', () => {
            _self.openAddOrder = false;
            swal('Uspešno', 'Uspešno izmenjeno vozilo', 'success')
            _self.getVehicles();
        });

    },

    beforeMount() {
        if (session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/login');
            return;
        }
        this.getVehicles()
    },
    watch: {
        'filter': function (newVal) {
            if (newVal.length === 0){
                // this.pagination.page = 1;
                // this.getDrivers();
            }
        },
    }
}

function editVehicle(vehicle) {
    this.vehicleToEdit = vehicle;
    this.openAddOrder = true;
}

function openAddUserModal() {
    this.vehicleToEdit = null;
    this.openAddOrder = true;
}

function clickSearch() {
    // this.pagination.page = 1;
    // this.getDrivers()
}

function getVehicles() {
    var _self = this;
    AdminApiService.getVehicles()
        .then((response) => {
            _self.vehicles = response.data;
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function keymonitor(event) {
    if (event.key === 'Enter') {
        this.getVehicles();
    }
}



function onClickUser(user) {
    swal({
        title: ''+user.name + ' '+ user.surname,
        html : '<html><div class="foo">' +
            '<br><div><b>Korisničko ime:</b>&ensp;'+ user.username+'</div><br>'+
            '<div><b>Email:</b>&ensp;'+ user.email+'</div><br>'+
            '<div><b>Telefon:</b>&ensp;'+ user.phone+'</div><br>'+
            '<div><b>Preostalo treninga:</b>&ensp;'+ user.restOfTraining+'</div><br>'+

            '</div></html>',
        text: "",
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Zatvori',
        customClass: 'swal2-warning'
    }).then(function () {

    });
}


function deleteVehicle(item) {
    var _self = this;
    swal({
        title: 'Da li ste sigurni?',
        text: "Da li ste sigurni da zelite da obrisete vozilo " + item.name + "?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        _self.$topnavbar.$emit('load');
        AdminApiService.deleteVehicle(item.id)
            .then((response) => {
                swal('Uspešno', 'Uspešno ste obrisali vozilo', 'success')
                _self.getVehicles();
            })
            .catch((error) => {
                swal('Greška', error.data.message, 'error')
            })
    });
}

function getFuel(fuel){
    switch (fuel) {
        case "GASOLINE": return "BENZIN";
        case "DIESEL": return "DIZEL";
        case "TNG": return "TNG";
        case "METHANE": return "METAN";
        case "ELECTRIC": return "ELEKTRIČNI";
        case "HYBRID": return "HIBRID";
        default: return ""
    }
}

function openCosts(vehicle){
    this.$router.push('/vehicle-costs?id=' + vehicle.id + '&name=' + vehicle.name + '&reg=' + vehicle.registrationPlate);
}

function styleRegistration(vehicle){
    if(this.isOwnVehicle(vehicle)) return ''
    var diff = vehicle.kilometersTraveled != null ? vehicle.smallService - (vehicle.kilometersTraveled - vehicle.lastSmallService) : 0
    if(diff <= 500){
        return 'background: red;';
    }
    return '';
}

function styleService(vehicle){
   if(this.isOwnVehicle(vehicle)) return ''
    var diff = vehicle.kilometersTraveled != null ? vehicle.smallService - (vehicle.kilometersTraveled - vehicle.lastSmallService) : 0
    if(diff <= 500){
        return 'background: red;';
    }
    return '';
}

function isOwnVehicle(vehicle){
    return  vehicle.registrationPlate === "B" || vehicle.registrationPlate === "b" || vehicle.registrationPlate === "*"
}

function parseDate(date){
    var calendarTimestamp = 0;
    try{
        var temp = date.split(".").filter(e => e.length > 0)
        calendarTimestamp = Date.parse(temp[2]+"-"+temp[1]+"-"+temp[0])

    }catch (e){}
    let limitDays = 2678400000//1000 * 60 * 60 * 24 * 31 //- 31 dan
    if(calendarTimestamp - Date.now() <  limitDays ){
        return 'background: red;';
    }
    return '';
}


// WEBPACK FOOTER //
// ./src/components/Vehicle/Vehicle.js